import { render, staticRenderFns } from "./ResolucionForm.vue?vue&type=template&id=1d46dbc7"
import script from "./ResolucionForm.vue?vue&type=script&lang=js"
export * from "./ResolucionForm.vue?vue&type=script&lang=js"
import style0 from "./ResolucionForm.vue?vue&type=style&index=0&id=1d46dbc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports